import { Flex } from '@rebass/grid';
import { css, styled } from 'styles';

export const Container = styled(Flex)`
  background: #191919;
  border-radius: 4px;
  padding: 16px;
  line-height: 1;
  flex: 1;
  position: relative;

  h2 {
    font-size: 2rem;
    font-weight: 600;
  }
`;

export const Label = styled.div`
  font-size: 1.2rem;
  line-height: 1.4;
`;

export const Value = styled.div`
  font-size: 1.4rem;
  line-height: 1.4;
  font-weight: ${({ theme }) => theme.fonts.boldWeight};
  text-transform: uppercase;
`;

export const Rank = styled.span`
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  position: absolute;
  right: 16px;
  top: 16px;
  font-size: 1.2rem;
  font-weight: 600;
  padding: 4px 6px 2px;
`;

export const TrophyIcon = styled.span`
  color: rgba(255, 255, 255, 0.3);
  vertical-align: middle;
  margin-right: 5px;
`;

export const ChartIconWrapper = styled.span`
  vertical-align: middle;
  display: inline-block;
  padding: 0 2px 0 5px;
  font-size: 1.1em;
`;

export const PercentageValue = styled.span<{ percent: number }>`
  ${({ percent }) =>
    percent > 0 &&
    css`
      color: #00b96c;
    `}

  ${({ percent }) =>
    percent < 0 &&
    css`
      color: #e81732;
    `}
`;
